import { Collapse, Stack, styled } from '@ethings/ui-toolkit';
import { Box, duration } from '@mui/material';
import { FC, type JSX } from 'react';
import { DrawerSize } from '../event-history.types';

interface Props {
  bottomDrawerContent: JSX.Element;
  bottomDrawerExited: boolean;
  closedDrawerSize: number;
  bottomDrawerHeight: DrawerSize;
  fullScreenIcon?: JSX.Element;
  handleBottomDrawerEnter: () => void;
  handleBottomDrawerExit: () => void;
  setBottomDrawerHeight: (height: DrawerSize) => void;
  topDrawerContent: JSX.Element;
}

interface StyledCollapseProps {
  bottomDrawerExited: boolean;
  bottomDrawerHeight: DrawerSize;
  closedDrawerSize: number;
}

const StyledCollapse = styled(Collapse, {
  shouldForwardProp: (prop) => prop !== 'bottomDrawerExited' && prop !== 'bottomDrawerHeight' && prop !== 'closedDrawerSize',
})<StyledCollapseProps>(({ bottomDrawerExited, bottomDrawerHeight, closedDrawerSize }) => ({
  height: bottomDrawerExited
    ? closedDrawerSize
    : bottomDrawerHeight === DrawerSize.OPEN
      ? '50vh !important'
      : `${bottomDrawerHeight}px !important`,
  overflowY: bottomDrawerExited ? 'visible' : 'auto',
  scrollbarWidth: 'none',
  '::-webkit-scrollbar': { display: 'none' },
}));

export const TwoWayCollapseLayoutDesktop: FC<Props> = ({
  bottomDrawerContent,
  bottomDrawerExited,
  bottomDrawerHeight,
  closedDrawerSize,
  handleBottomDrawerEnter,
  handleBottomDrawerExit,
  topDrawerContent,
}): JSX.Element => {
  return (
    <Stack height="inherit" flexGrow={1} minHeight={0} minWidth={0} overflow="hidden">
      <Stack className="map-resize-listener" flexGrow={1} minHeight={0} minWidth={0}>
        <Box
          sx={{
            '&': {
              transition: `height ${duration.standard}ms linear`,
            },
            width: '100%',
            height: bottomDrawerHeight !== DrawerSize.FULL_SCREEN ? '100% !important' : 0,
          }}
        >
          {topDrawerContent}
        </Box>
      </Stack>
      <StyledCollapse
        bottomDrawerExited={bottomDrawerExited}
        bottomDrawerHeight={bottomDrawerHeight}
        closedDrawerSize={closedDrawerSize}
        collapsedSize={closedDrawerSize}
        in={bottomDrawerHeight !== DrawerSize.CLOSED}
        onEnter={handleBottomDrawerEnter}
        onExiting={handleBottomDrawerExit}
        orientation="vertical"
      >
        <Stack px={3} py={bottomDrawerHeight === DrawerSize.CLOSED ? 0 : 3}>
          {!bottomDrawerExited && bottomDrawerContent}
        </Stack>
      </StyledCollapse>
    </Stack>
  );
};
